function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import { declMod, bool2string } from '@yandex-lego/i-bem-react';
import _textinput__icon from "./../__icon/textinput__icon.react.js";

var TextInputIcon = _textinput__icon.applyDecls();

import "./../__icon/textinput__icon.css";
import "./../__icon/_side/textinput__icon_side_left.css";
import "./../__icon/_side/textinput__icon_side_right.css";
export default declMod(function (_ref) {
  var iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      icon = _ref.icon;
  return iconLeft || iconRight || icon;
}, {
  block: 'textinput',
  mods: function mods(_ref2) {
    var iconLeft = _ref2.iconLeft,
        iconRight = _ref2.iconRight,
        icon = _ref2.icon,
        hasClear = _ref2.hasClear,
        type = _ref2.type;

    /*%%%ISLDEBUG%%%*/
    +0 && console.assert(!(iconRight && hasClear), 'textinput: Возможность передавать iconRight одновременно ' + 'с модификатором _has_clear объявлена deprecated');
    return _objectSpread({}, this.__base.apply(this, arguments), {
      'has-icon': bool2string(iconLeft || iconRight || icon),
      'icon-right': bool2string(iconRight)
    });
  },
  content: function content(_ref3) {
    var iconLeft = _ref3.iconLeft,
        iconRight = _ref3.iconRight,
        icon = _ref3.icon;
    var content = [];
    (icon || iconLeft) && content.push(React.createElement(TextInputIcon, {
      side: "left",
      key: "left"
    }, iconLeft || icon));
    iconRight && content.push(React.createElement(TextInputIcon, {
      side: "right",
      key: "right"
    }, iconRight));
    return [].concat(content, this.__base.apply(this, arguments));
  }
}, {
  propTypes: {
    iconLeft: PropTypes.object,
    iconRight: PropTypes.object
  }
});